import { createQueryKeys } from "@lukemorales/query-key-factory"

export default createQueryKeys("suraasaPlus", {
  retrieveSubscription: (params: Record<string, any>) => ({
    queryKey: ["retrieveSubscription", params],
  }),
  productDetails: ({
    slug,
    params,
  }: {
    slug: string
    params?: Record<string, any>
  }) => ({
    queryKey: ["product-details", slug, params],
  }),
  retrieveRuleExecutionDetails: (params: Record<string, any>) => ({
    queryKey: ["retrieveRuleExecutionDetails", params],
  }),
})
